import { Box, Link, Typography } from "@mui/material";

import { Button, Modal } from "@covertree/ui";

import { AGENT_HELP_ADDRESS } from "@consts/index";

interface ActiveRenewalModalProps {
  readonly isModalOpen: boolean;
  readonly onClose: () => void;
}

export function ActiveRenewalModal({
  isModalOpen,
  onClose,
}: ActiveRenewalModalProps) {
  return (
    <Modal
      open={isModalOpen}
      onClose={onClose}
      title="Renewal In Progress"
      maxWidth={false}
      sx={{
        width: { xs: "80%", md: 720 },
        "&:focus": {
          outline: "none",
        },
      }}>
      <Typography variant="h5" sx={{ pr: 5, textAlign: "justify" }}>
        It is not possible to complete this action at this time because renewal
        has already been processed. Please try again once the renewal becomes
        effective.
        <br />
        If you need assistance, contact{" "}
        <Link color="secondary" href={`mailto:${AGENT_HELP_ADDRESS}`}>
          {AGENT_HELP_ADDRESS}
        </Link>
        .
      </Typography>
      <Box mt={4} columnGap={3} display="flex">
        <Button onClick={onClose}>Close</Button>
      </Box>
    </Modal>
  );
}
